@if (printModel.ShowPrintModel) {
  <div class="margin_top">
    <button type="button" class="btn print-btn" (click)="printRoutePlan()"><span>Print</span></button>
  </div>
}